import { anchorate } from 'anchorate';

export const onRouteUpdate = ({ location }) => {
  if (window.piTracker) piTracker(location.href);
  anchorate();
};

export const onClientEntry = () => {
  // Create global variable for Mouseflow to agregate data
  window.mouseflowPath = '/soft-launch';
};
